import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { PlayerSearch as NYYPlayerSearch } from 'yankees-react-utils';
import { Search as searchData, useOktaQuery } from '../data';

const PlayerSearch = ({ isPitcher, isCatcher, ...rest }) => {
    const [criteria, setCriteria] = useState();
    const [shouldDoFetch, setShouldDoFetch] = useState(false);
    const { data, isLoading, remove } = useOktaQuery(
        ['search-players', criteria, isPitcher, isCatcher],
        (t) => searchData.players(t, { criteria, isPitcher, isCatcher, allowTwoWay: true }),
        { enabled: shouldDoFetch },
    );

    const search = (searchCriteria, shouldFetch) => {
        setCriteria(searchCriteria);
        setShouldDoFetch(shouldFetch);
    };
    const onHide = () => {
        setShouldDoFetch(false);
        remove();
    };

    return (
        <NYYPlayerSearch search={search} isLoading={isLoading} results={data} onHide={onHide} {...rest} />
    );
};

PlayerSearch.propTypes = {
    isPitcher: PropTypes.bool,
    isCatcher: PropTypes.bool,
};
PlayerSearch.defaultProps = {
    isPitcher: null,
    isCatcher: null,
};

export default PlayerSearch;
